<div class="my-favourites-window">

  <div class="group-toolbar">
    <div class="group-toolbar-configuration">
      <div
        style="margin-right: 10px; margin-top: 3px;"
        class="with-tip"
      >
        <a
          href="https://youtu.be/y5nlxahH9tQ"
          target="_blank"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVRIidWVz2sTQRTHP7MbqQpeKkWjUaFHA/5AJclJT55ELdEcPHqSgggWFEHMBIr2oB56Kf0LxMVgvfQfUGoMlGoCOYqkNSlSDXixLc0+D0maTTObXb31Cwszs9/3/c5785iB3Q4VyHAcm0glhagEIkfbqytYFCmxgNbu/xnMTw+x3hhH5CFwyIe1iqgpXJkhozfDG+R1DJgDzg3anQclLK4xpr8FG+QnT8BWATgcUryDOk2SZHTV32B+eog/v4rAKYPAF1BvW0MZA04bOEttk+1yWT2/1xvjRnHFK4Y5TzqbI53NsRa9ALw2GJwlwh1zBo5jY1e+03+gW1iMIMQQ3rUSsK6yd0+NjY0fQGQHv06ZWKe7uhlEKimDOEADlwzwAhgFRrHc21x51AC+GvhR4iQ7E2+JkgYywAgwi3C5Pd+kac3hvNwHRI0RymxgJveiiahb3HzyHvu3Bg74GBwxGYTBU25k8+RzE8CDMAFdA1G1EPz9vNH3QZ4PZAnbWp4OUAWQIIOJELcXKBY6w24GZfcjsBoQ+qH9DUKNMsV+A61dRE0NCKxS5iLNk5eAZV+W8Mx7w/YesiszCJ99Qg9yxopjVeLAsA9nkZ/RWe9Cf0UdfRybAuHa1osadiTJ9cc92fW3aUZXaZIElv5BfBFI7BQ3G3hNFPeA+gDhOsJd1qIp0nrFRAhuOq0t4iSxVQJXjrW2pZZBFSi5n4KezN2Pvw7WpK5LkS4RAAAAAElFTkSuQmCC"/>
        </a>
        <span
          class="tip"
          style="text-align: center; padding: 5px; width: 140px;"
        >
        Watch tutorial
        </span>
      </div>

      <div
        class="button-container"
        style="margin: 0"
      >
        <button
          id="removeSelected"
          class="iv-flat-button"
          (click)="onRemoveSelectedClick()"
          [class.disabled]="selectedGroup?.isDefault || !selectedStocks.length"
        >Remove selected
        </button>

        <div
          id="imageRemoveSelected"
          class="with-tip"
        >
          <button
            class="iv-img-button"
            (click)="onRemoveSelectedClick()"
            [class.disabled]="selectedGroup?.isDefault || !selectedStocks.length"
          >
            <div class='square-content'>
              <div>
                <img
                  style="padding-top: 2px;"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA30lEQVRIid2SvRIBMRSFv+xqvIjCyyjW7DswZpR00mp5jn0iKgYNFYWf3Y1ijTGStUlQcMpMzvnuzQn8uoTVrURKYPR0OiaSQzdAIpXlYK8VyXtu8JHAv5ZeciKnQM8rTTGhLfuPR6YOll7hRZrm1QGChTdACQuACvw3EEIbTgeEwRsb5BYbnBtrIPWIT8mam2pAHGeAdtFCq5u3AlDIpwejpwzg04PRYwaIb29g+M+VEmZPCUC5A3K3J3LvIDQPZQbU6jPg5BB/5MLcHtAa7FF0gZ1F+BboEMuDw0A/pCuhbj3pF4KPYgAAAABJRU5ErkJggg=="
                >
              </div>
            </div>
          </button>
          <span
            class="tip"
            style="text-align: center; padding: 5px; width: 140px;"
          >
            Remove selected
          </span>
        </div>
      </div>

      <div class="button-group">
        <div class="with-tip">
          <button
            class="iv-img-button"
            style="margin: 0"
            (click)="onUploadDataClick()"
            [class.disabled]="currentGroupStocks && !currentGroupStocks.length"
          >
            <div class='square-content'>
              <div>
                <span class="material-icons">&#xE884;</span>
              </div>
            </div>
          </button>
          <span
            class="tip"
            style="text-align: center; padding: 5px; width: 140px;"
          >
          Download data
        </span>
        </div>

        <div class="with-tip">
          <button
            id="editColumnsButton"
            class="iv-img-button with-tip"
            style="margin: 0"
            (click)="onEditColumnsClick()"
          >
            <div class='square-content'>
              <div>
                <span class="material-icons">&#xE8B8;</span>
              </div>
            </div>
          </button>
          <span
            class="tip"
            style="text-align: center; padding: 5px; width: 140px;"
          >
            Column Settings
          </span>
        </div>
        <iv-live-image-button
          id="calculatorButton"
          style="margin: 0"
          (buttonClicked)="onCalculatorButtonClick()"
          [tip]="'Calculator'"
        >
          <img
            src="data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABlQAAAZUBDE2OiAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACxSURBVEiJ7ZPLDcIwEESfUbpACEE93EIRudDD1pBDuoBjyskFQRvLIUIQbxLnJwVLzM2j9e7Mjg2xwxnmJieUHDiM7FWhXDhL+U1uTJlSTGgOcMRR+GTSUrgDIBXrrg9XUWDv09bBwoh/QFsGNeqdzsbKK0rFNV5T6Dx6wAKw0+fu3nP0zyCI+DPo/snwUfN21bXvHterOHgAW8AqC+dz9wnrwJEBz4ECm8KUbMK9H8cL0RIuy8jrs/gAAAAASUVORK5CYII=
      "
          >
        </iv-live-image-button>
      </div>
    </div>

    <div class="group-toolbar-filters">
      <iv-live-group-dropdown
        id="groupDropdown"
        style="margin-left: 10px;"
        [data]="getAllGroups()"
        [selectedData]="selectedGroup"
        (selectedDataChange)="handleGroupClick($event)"
        [valueAttribute]="'name'"
        [label]="'Group'"
        [cssClass]="'group-select'"
        (deleteGroupEvent)="onDeleteGroupApply($event)"
        (renameGroupEvent)="onRenameGroupApply($event)"
        (closeOtherDropdown)="openDropdown(1)"
      >
      </iv-live-group-dropdown>

      <div id="newGroupButton">
        <button
          id="groupButton"
          class="iv-flat-button"
          style="margin-left: 5px;"
          (click)="openCreateGroupDialog()"
        >+ New
          group
        </button>

        <iv-live-image-button
          id="imageGroupButton"
          style="margin-left: 5px"
          (buttonClicked)="openCreateGroupDialog()"
          statistic
          [statisticElementName]="'Futures monitor new group'"
          [tip]="'New group'"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAB/UlEQVRIie2Wv24TQRCHvzlfqEiNBFYUFIq8Q8IDQCRscxAK0lHQAaKgIcJjiSegRHShsrigOI7oIcor0EWRcEiftPYuxdnS/b+NsRFFft3Ozu63P3tn9uBK/0jinNnVJWrSALuBsIylPt5hgOUESx/f36O5/Ws24O77W9SG74BnQK0i2wAhHm9o6cn04C/aRNgBrlceMKkLYItAe0UJXjG08xIhnAIKsAh8ZVdfFCXkO46chqUHc5MBWnnOs+BQ68BPpnOapwt8Vmno73gw60joOEENawh3HcCLDOlkMXF1dYkax1TfXgg0WhuqdYCPgGUCHUwCScc+TSfo5VVDpBEPJMGWe3OAjve294vBcGduYGElPvRT0zdyFxnWeKxHuXOT/3qiXV3H8iOTZ7kZH7rVqee59/SRW27a8RlR10nJHBJqMlR4q00R6zQ+SDs+Ljnk3yqxd/pWH8wNa6VfDPb9PaJin7WGiN2PB/J69Seit7dC3joGD898dwB/JNDnidWZlJHfJnpPK2QOnaCWc1jQdDgL3tw+xZMnzOYnNyBbBG/PqsEArfY3hNeU1IYj9BWP2vt5k+XFHuoD4DO5tV0iyzkeT3mo/aKU8s4VaI/RtRUsH4ChA9IAO8jCahkULvN5G2odkQbGbiDchvHnLQyImsMB0Iu/uVf6L/QHMaKESQrQ1OIAAAAASUVORK5CYII="
          >
        </iv-live-image-button>
      </div>

      <div>
        <button
          id="renameButton"
          class="iv-flat-button with-tip"
          [class.disabled]="selectedGroup?.isDefault"
          style="margin-left: 5px;"
          (click)="onRenameGroupClick()"
          statistic
          [statisticElementName]="'Futures monitor rename group'"
        >Rename group
        </button>

        <iv-live-image-button
          id="imageRenameButton"
          (buttonClicked)="onRenameGroupClick()"
          statistic
          [statisticElementName]="'Futures monitor rename group'"
          [tip]="'Rename group'"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAzElEQVRIie2UMQ7CMAxFX6D3QpwhVKxsXICBASkOGwM7GwsLQzlDL0bLQCvRNkWhNQMSf0pi5T3ZkQK/HqNCyWQHbMCsse6qK8hEAFft7pSsWMilLk9GC5qZYjiT+eV4wW0/A8CKAP6lkkB5GifIRCiLvBpPSHKsF5+/QXPmAL4S0BIOEHThdQ5Y2YauxAv64c8UzEklbx8nKnCMkLoOHGI6iIFb53ur34S/FyjA+wVK8LBAEd4VKMOh+1WowkMCVXikYDg8QjAO/k9UHuxOTayisqXsAAAAAElFTkSuQmCC"
          />
        </iv-live-image-button>
      </div>

      <div>
        <button
          id="deleteSelectedGroup"
          class="iv-flat-button with-tip"
          style="margin-left: 5px"
          [class.disabled]="selectedGroup?.isDefault == true"
          (click)="openDeleteGroupDialog()"
          statistic
          statisticElementName="Click Futures Monitor delete group"
        >
          Delete group
        </button>
      </div>

      <div class="search">
        <dx-autocomplete
          [dataSource]="futures"
          [(value)]="stockName"
          class="search-field"
          placeholder="Search symbols to add in group"
          valueExpr="nameAndExchange"
          searchMode="StartsWith"
          [showClearButton]="true"
          (onItemClick)="onAutocompleteItemClick($event)"
          (onKeyDown)="onAutocompleteKeyDown($event)"
          [elementAttr]="{ class: 'instrument-select', style: 'transform:none;'}"
        >
          <div
            *dxTemplate="let item of 'item'"
            class="instrument-select-item favourites-instrument-select-item"
          >
            <div class="instrument-select-item__name-container">
              <div class="name-and-exchange">{{item.nameAndExchange}}</div>
              <div class="stock-type">
                {{getStockType(item)}} - {{item.region}}
              </div>
            </div>
            <div class="instrument-select-item__company-container">
              <div
                class="company"
                title="{{item.company}}"
              >
                {{item.name}}
              </div>
            </div>
          </div>
        </dx-autocomplete>
      </div>

      <div id="showAdvancedSearchButton">
        <button
          id="advancedSearch"
          class="iv-flat-button"
          (click)="onSearchButtonClick()"
        >Advanced search
        </button>

        <button
          id="imageAdvancedSearch"
          class="iv-img-button with-tip"
          (click)="onSearchButtonClick()"
          type="button"
        >
          <div class='square-content'>
            <div>
              <img
                style="padding-top: 3px"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACpElEQVRIidXUP2icdRgH8M/vLlftIVlEtJ0iiA5CEcU/S6MBJyFCkiOlWqFYHFxam9Khg+QXURdpbQd1UYMFMca7K/ing0OhYwSFRBDEoYOLdugQJWma3P0c7i73570kB538Tu/7vM/z/X6fP7z83xEGyqrMnSB92hVLTijFz/cqzQ3mI432sXZ4kMq9BcrvPI6sAC80v+2K7hElQSV+izv4WvA83szkdVbwieQ6jmCfqfiyIPUXqMTjmN/L1a5I4bjS7BdZgcV4n7zfcfCuBPjbukcdi6t07mDI2V3I/5RCydD+YUOFhwRHcWOH3AcVnWnTtlC3JFhDMUNe84Tp2VvN93+woBqvSZYw0pO/pm6p9dLuoBSvyhnDeld6CqdNx1t6MRlvSt7uia7LGVOKV7MCMBF/Qr0rVrj3xwx5C/eoyucOqQ0X1dwvlzvc5NjG0E61bWwVNcaSxXhcw6/b7sl02i1wJT6j3tNVbXMMC30FKrEkOCl5shn5WXDJZKy2UtpnWo4vCb6RXfINwXMm482uaDVelJzqKxxcMBnP0LmDnGf7kMPDkiWVudd8F4vbzhvkt3FazQEKB4Uwg9uSGZW5CTpHtOUDeW/gQB+REdJlG5ax0hwLnDMVL3bkfagcg+A86RSutDuYjv9K4VzflluoD/8B2zOv9dlNofBl8+mpxmA6MTV7WfK9pCo5IvlI59nuX23trOE/X8j+BLe2OTfovaIgEcc7IosW48fyfsCIDY9gBb9gVNo8igvdHJuvNuWXswL9MB1/U43XJSOEcY0dXJKMCt5TjoTCV037r0jp3WaP8w3Pg6AcXxd8hr+se8yxuKoaz0tmdqlaUdv34mACO6EyNyGkk5KnNU52WTIvOItDuHZ3Ajth8f0H5O8syOfe+g+3ocwY4kc4nwAAAABJRU5ErkJggg=="
              >
            </div>
          </div>
          <span
            class="tip"
            style="right: 0; text-align: center; padding: 5px 20px;"
          >
            Advanced search
          </span>
        </button>
      </div>
    </div>


  </div>

  <div class="middle-flex">
    <iv-live-grid
      *ngIf="currentGroupStocks!=null&&gridColumns!=undefined&&gridVisibleColumns!=undefined"
      [data]="currentGroupStocks"
      [columns]="gridColumns"
      [visibleColumns]="gridVisibleColumns"
      [emptyMessage]="emptyMessage"
      [cssClass]="'group-table'"
      (allRowsSelection)="toggleAllRowsSelection($event)"
      (columnSorting)="handleSorting($event)"
      (checkboxClick)="onCheckboxClick($event)"
      (symbolClicked)="onSymbolClick($event)"
      (chartButtonClicked)="onChartButtonClicked($event)"
      (calculatorButtonClicked)="onCalculatorButtonClick($event)"
    >

    </iv-live-grid>
    <ngx-spinner
      bdOpacity=0.5
      bdColor="rgba(51,51,51,0.1)"
      size="medium"
      color="#fff"
      type="ball-spin-clockwise"
      [fullScreen]="false"
      name=favouritesSpinner
    >
      <p style="color: white"></p>
    </ngx-spinner>
  </div>
</div>

<dx-popup
  [class]="editColumnsClass"
  [width]="415"
  [height]="586"
  [maxHeight]="'80vh'"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'Column Settings'"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [shading]="false"
  [(visible)]="editColumnsPopupVisible"
  [position]="editColumnsPopupPosition"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-columns-chooser
      [visibleColumns]="visibleColumns"
      [columns]="settingColumns"
      (columnSwitch)="onColumnSwitch($event)"
      (saveDefault)="saveDefault($event)"
    >
    </iv-live-columns-chooser>
  </div>
</dx-popup>

<dx-popup
  class="create-popup"
  [width]="240"
  [height]="130"
  [showTitle]="false"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [(visible)]="createPopupVisible"
  [position]="{ my: 'left top', at: 'bottom', of: '#newGroupButton'}"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-group-creation-popup-content
      serviceName="Futures Monitor"
      [existingGroups]="groups"
      (applyName)="onGroupNameApply($event)"
      (closePopup)="createPopupVisible = false"
    ></iv-live-group-creation-popup-content>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="deleteGroupPopupVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="115"
  [position]="{ my: 'left top', at: 'bottom', of: '#newGroupButton'}"
  [shading]="false"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="286"
  class="delete-popup"
  title="popup"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-confirmation-popup-content
      (confirmPopup)="onDeleteGroupAccept()"
      (closePopup)="onPopupCancel($event)"
      [message]="'Are you sure you want to delete group ' + JSON.stringify(selectedGroup.name) + '?'"
      confirmButtonText="Delete"
      popupSwitchName="deleteGroupPopupVisible"
      confirmButtonStatisticName="Click Futures Monitor delete group apply"
      cancelButtonStatisticName="Click Futures Monitor delete group cancel"
    ></iv-live-confirmation-popup-content>
  </div>
</dx-popup>

<dx-popup
  class="advanced-search-popup"
  [width]="660"
  [height]="570"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [(visible)]="advancedSearchVisible"
>
  <div *dxTemplate="let data of 'title'">
    <span class="dx-popup-title__text">Advanced search</span>
    <div class="dx-popup-title__close" (click)="onPopupCancel('advancedSearchVisible')">
      <img src="iv-live/assets/icons/chart-service/charts-icons/close.svg">
    </div>
  </div>
  <div *dxTemplate="let data of 'content'">
    <iv-live-advanced-search
      [hasMultipleChoice]="true"
      [isFuture]="true"
      (addSymbols)="onAddSymbols($event)"
      (closeDialog)="onPopupCancel('advancedSearchVisible')"
    ></iv-live-advanced-search>
  </div>
</dx-popup>

<dx-popup
  class="chart-window"
  [width]="'50%'"
  [height]="'50%'"
  [showTitle]="true"
  [shading]="false"
  title="IVX Monitor {{selectedFuture?.stockName}}"
  [showCloseButton]="true"
  [(visible)]="chartsPopupVisible"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-ivx-chart
      *ngIf="selectedFuture && selectedFuture.underlyingId"
      [instrument]="selectedFuture.underlyingId"
      style="height: 98%;"
    ></iv-live-ivx-chart>
    <div class="ivol-view">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  class="create-popup"
  [width]="900"
  [height]="calculatorType === 'options' ? 520 : 464"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [focusStateEnabled]="true"
  [(visible)]="calculatorPopupVisible"
  [position]="{  my: 'center', at: 'center', of: 'iv-live-my-favorites'}"
  [shading]="false"
  titleTemplate="title"
>
  <div
    *dxTemplate="let data of 'title'"
    style="background-color: #272B29;width: 100%;display: block; padding: 0 16px; border: none; border-radius: 16px 16px 0 0"
  >
    <iv-live-common-calculator-header
      [userPermissionMode]="mode"
      [isControlsShown]="+sessionStorage.getItem('currentStockRegion') === 1"
      [isEod]="isEODOptions && isEODProbability"
      [isFutures]="true"
      (switchMode)="switchCalculatorMode()"
      (switchType)="switchCalculatorType($event)"
      (closeCalculator)="calculatorPopupVisible = false"
      style="position: relative; top: 16px;"
    >
    </iv-live-common-calculator-header>
  </div>

  <div *dxTemplate="let data of 'content'">
    <div style="background-color: #272B29;padding:16px;height: 100%; border-radius: 0 0 16px 16px; margin-top: -1px">
      <iv-live-futures-calculator
        [ngStyle]="{'display': calculatorType === 'options' ? 'inline' : 'none'}"
        [future]="selectedFuture"
        [futures]="futures"
        [mode]="mode"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionOptions($event.region)"
        (showMessageEvent)="calculatorMessage($event)"
        (openDropdownEvent)="closeProbabilityDropdown()"
        (onFutureChange)="selectedFuture = $event"
      >
      </iv-live-futures-calculator>
      <iv-live-probability-calculator
        [ngStyle]="{'display': calculatorType === 'probability' ? 'inline' : 'none'}"
        [instrument]="selectedFuture"
        [instruments]="futures"
        [mode]="mode"
        (returnRegionEvent)="returnRegionProbability($event.region)"
        (showMessageEvent)="calculatorMessage($event)"
        (closeButtonClicked)="closeCalculatorWindow()"
        (openDropdownEvent)="closeFuturesDropdown()"
        (onInstrumentChange)="selectedFuture = $event"
      ></iv-live-probability-calculator>
    </div>
  </div>
</dx-popup>

<dx-popup
  class="create-popup"
  [width]="500"
  [height]="! isError ? 500 : 230"
  [showTitle]="true"
  [showCloseButton]="false"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [focusStateEnabled]="true"
  [(visible)]="popupCredit"
  [position]="{  my: 'center', at: 'center', of: 'iv-live-my-favorites'}"
  [shading]="false"
  titleTemplate="title"
>
  <div
    [style.backgroundColor]="themeColor === themeColorEnum.DARK ? '' : '#f1f2f7'"
    style="display: flex; padding: 0; border-bottom: none; height: 40px;"
    *dxTemplate="let data of 'title'"
  >
    <iv-live-credit
      *ngIf="popupCredit"
      [minus]="3"
      [isError]="isError"
      (cancel)="popupCredit=false"
      (proceed)="uploadData()"
    >
    </iv-live-credit>
  </div>
</dx-popup>
